export const updateHideDashboardOnSidenavReducer = {
  updateHideDashboardOnSidenav: (state, action) => {
    state.hideDashboardTabOnSidenav = action.payload;
  },
};
